import React, { useEffect } from 'react';
import './App.css';
import Main from './pages/Main';
import { LoadingProvider } from './context/LoadingContext';
import { UserProvider } from './context/useUser';
import { CartProvider } from './context/useCart';
import { ProductProvider } from './context/useProducts';
import { WishlistProvider } from "./context/useWishList";
import { initFBPixel } from './facebookPixel';

function App() {

  useEffect(() => {
    initFBPixel();
  }, []);

  return (
    <>
      <ProductProvider>
        <WishlistProvider>
          <CartProvider>
            <UserProvider>
              <LoadingProvider>
                <Main />
              </LoadingProvider>
            </UserProvider>
          </CartProvider>
        </WishlistProvider>
      </ProductProvider>
    </>
  );
}

export default App;
